import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const NamesListModal = ({ show, onClose }) => {
  const [names, setNames] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (show) {
      fetchNames();
    }
  }, [show]);

  const fetchNames = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch('https://names-storage.t9e2i3kal.workers.dev/list');
      if (response.ok) {
        const data = await response.json();
        setNames(data || []);
      } else {
        throw new Error('Failed to fetch names');
      }
    } catch (err) {
      console.error('Failed to fetch names:', err);
      setError('Failed to load names. Please try again.');
      setNames([]);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    onClose();
  };

  if (!show) return null;

  return (
    <div className="password-modal-overlay">
      <div className="password-modal" style={{ maxWidth: '600px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
          <h2>Names List</h2>
          <button className="close-btn" onClick={handleClose} aria-label="Close">
            <X size={24} />
          </button>
        </div>
        
        {error && (
          <div style={{ 
            backgroundColor: 'rgba(220, 53, 69, 0.1)', 
            border: '1px solid var(--danger)', 
            borderRadius: 'var(--radius)', 
            padding: 'var(--space-3)', 
            marginBottom: 'var(--space-4)',
            color: 'var(--danger-light)'
          }}>
            {error}
          </div>
        )}
        
        <div style={{ 
          maxHeight: '400px', 
          overflowY: 'auto',
          border: '1px solid var(--surface-3)',
          borderRadius: 'var(--radius)',
          backgroundColor: 'var(--surface-2)'
        }}>
          {loading ? (
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              padding: 'var(--space-8)' 
            }}>
              <div className="spinner"></div>
            </div>
          ) : names.length === 0 ? (
            <div style={{ 
              padding: 'var(--space-6)', 
              textAlign: 'center', 
              color: 'var(--text-muted)' 
            }}>
              No names found
            </div>
          ) : (
            <ul style={{ 
              listStyle: 'none', 
              margin: 0, 
              padding: 0 
            }}>
              {names.map((name, index) => (
                <li 
                  key={index} 
                  style={{ 
                    padding: 'var(--space-3) var(--space-4)', 
                    borderBottom: index < names.length - 1 ? '1px solid var(--surface-3)' : 'none',
                    color: 'var(--text-secondary)'
                  }}
                >
                  {name}
                </li>
              ))}
            </ul>
          )}
        </div>
        
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          marginTop: 'var(--space-6)',
          gap: 'var(--space-4)'
        }}>
          <button className="btn btn-sm" onClick={fetchNames} disabled={loading}>
            {loading ? 'Refreshing...' : 'Refresh'}
          </button>
          <button className="btn btn-sm" onClick={handleClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default NamesListModal;